import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Terminos() {
  const [doc, setDoc] = useState(null);
  useEffect(() => {
    api.get("/public/legal").then((r) => setDoc(r.data.documentos.find((d) => d.documento === "terminos_uso")));
  }, []);
  return (
    <div className="min-h-screen bg-slate-50 px-5 py-10" data-testid="terminos-page">
      <div className="max-w-3xl mx-auto space-y-4">
        <Link to="/" className="text-sm underline" data-testid="terminos-back">← Volver</Link>
        <h1 className="font-heading text-3xl font-bold">{doc?.titulo || "Términos de uso"}</h1>
        {doc && <p className="text-sm text-slate-500">Versión {doc.version}</p>}
        <pre className="whitespace-pre-wrap font-sans text-base text-slate-700 bg-white border rounded-xl p-5" data-testid="terminos-texto">{doc?.texto}</pre>
      </div>
    </div>
  );
}
